import React from "react";
import { FaUserCheck, FaShieldAlt, FaEye, FaComments, FaThumbsUp, FaStar } from "react-icons/fa";
import API_BASE from "../config/api";

export default function Dashboard() {
    // 🔥 Read fullname from local storage
    const userData = JSON.parse(localStorage.getItem("user"));
    const fullName = userData?.fullname || "User";
    const [weather, setWeather] = React.useState({
        temp: null,
        city: "",
        country: ""
    });

    React.useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (pos) => {
                const { latitude, longitude } = pos.coords;

                // API : Open-Meteo (FREE + No key)
                const weatherRes = await fetch(
                    `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`
                );
                const weatherData = await weatherRes.json();

                // Reverse Geo API (FREE)
                const geoRes = await fetch(
                    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
                );
                const geoData = await geoRes.json();

                setWeather({
                    temp: weatherData?.current_weather?.temperature ?? 0,
                    city: geoData?.city || "Unknown",
                    country: geoData?.countryName || ""
                });
            });
        }
    }, []);

    const [stats, setStats] = React.useState({
        verified: 0,
        insurance: 0,
        pageview: 0,
        comments: 0,
        likes: 0,
        rating: 0
    });

    React.useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) return;

        fetch(`${API_BASE}/api/get_dashboard_data.php?personaluid=${user.personaluid}`)
            .then(res => res.json())
            .then(json => {
                if (json.success) {
                    setStats(json.data);
                }
            });
    }, []);


    return (
        <div className="container-fluid py-4" style={{ background: "#f7f9fc", minHeight: "100vh" }}>

            {/* Top Welcome Banner */}
            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >

                <h5 className="fw-bold text-dark mb-1">Welcome, {fullName}!</h5>
                <p className="text-secondary mb-0">
                    Your dashboard for viewing and updating your business insights.
                    <span className="text-primary fw-semibold"> You have 0 unread alerts.</span>
                </p>
            </div>

            <div className="row">
                {/* Left Section – Image + Weather */}
                <div className="col-md-6 mb-4">
                    <div className="card shadow-sm border-0" style={{ borderRadius: 20 }}>
                        <img
                            src="logo.png"
                            className="img-fluid p-2"
                            alt="people"
                        />
                        <div className="p-3 d-flex align-items-center">
                            <div>
                                <h2 className="fw-bold text-primary mb-0">
                                    <i className="bi bi-sun-fill me-2"></i>
                                    {weather.temp !== null ? `${weather.temp}°C` : "--"}
                                </h2>

                            </div>
                            <div className="ms-3">
                                <h5 className="fw-semibold mb-0 text-dark">{weather.city || "City"}</h5>
                                <p className="mb-0 text-muted">{weather.country || "Country"}</p>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Section — Stats Cards */}
                <div className="col-md-6">
                    <div className="row">

                        {/* Stat Card */}
                        <div className="col-md-6 mb-3">
                            <div
                                className="card shadow-sm border-0 p-2"
                                style={{ background: "#e9f4ff", borderRadius: 16 }}
                            >
                                <FaUserCheck size={26} className="text-primary mb-2" />
                                <h6 className="text-secondary mb-1">Verified Listing</h6>
                                <h4 className="fw-bold text-dark">
                                    {stats.verified ? "Yes" : "No"}
                                </h4>

                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div
                                className="card shadow-sm border-0 p-2"
                                style={{ background: "#eaf7ff", borderRadius: 16 }}
                            >
                                <FaShieldAlt size={26} className="text-info mb-2" />
                                <h6 className="text-secondary mb-1">Verified Insurance</h6>
                                <h4 className="fw-bold text-dark">
                                    {stats.insurance ? "Yes" : "No"}
                                </h4>

                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div
                                className="card shadow-sm border-0 p-2"
                                style={{ background: "#e6fff3", borderRadius: 16 }}
                            >
                                <FaEye size={26} className="text-success mb-2" />
                                <h6 className="text-secondary mb-1">Page Viewed</h6>
                                <h4 className="fw-bold text-dark">{stats.pageview}</h4>

                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div
                                className="card shadow-sm border-0 p-2"
                                style={{ background: "#fff5e5", borderRadius: 16 }}
                            >
                                <FaComments size={26} className="text-warning mb-2" />
                                <h6 className="text-secondary mb-1">Comments</h6>
                                <h4 className="fw-bold text-dark">{stats.comments}</h4>

                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div
                                className="card shadow-sm border-0 p-2"
                                style={{ background: "#e8f3ff", borderRadius: 16 }}
                            >
                                <FaThumbsUp size={26} className="text-primary mb-2" />
                                <h6 className="text-secondary mb-1">Likes</h6>
                                <h4 className="fw-bold text-dark">{stats.likes}</h4>

                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div
                                className="card shadow-sm border-0 p-2"
                                style={{ background: "#ffe8e8", borderRadius: 16 }}
                            >
                                <FaStar size={26} className="text-danger mb-2" />
                                <h6 className="text-secondary mb-1">Star Rating</h6>
                                <h4 className="fw-bold text-dark">{stats.rating}</h4>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    );
}
